const t = "8px", e = "8px", o = "8px", n = "8px", a = "8px", r = "8px", c = "8px", i = "8px", s = "8px", $f = 0, l = "768px", d = "1280px", f = "9999px", m = "9999px", S = "9999px", u = "9999px", g = "9999px", p = "9999px", v = "9999px", b = "9999px", B = "9999px", kf = {
  large: {
    radius: {
      mobile: t,
      tablet: n,
      desktop: c
    }
  },
  medium: {
    radius: {
      mobile: e,
      tablet: a,
      desktop: i
    }
  },
  small: {
    radius: {
      mobile: o,
      tablet: r,
      desktop: s
    }
  }
}, hf = {
  mobile: 0,
  tablet: l,
  desktop: d
}, Hf = {
  large: {
    radius: {
      mobile: f,
      tablet: u,
      desktop: v
    }
  },
  medium: {
    radius: {
      mobile: m,
      tablet: g,
      desktop: b
    }
  },
  small: {
    radius: {
      mobile: S,
      tablet: p,
      desktop: B
    }
  }
}, Cf = 0, Ff = "1px", Df = "2px", y = "linear-gradient(var(--gradient-angle, 90deg), var(--spirit-color-gradient-basic-overlay-color-01, #fff) 0%, var(--spirit-color-gradient-basic-overlay-color-02, #fff0) 100%)", $ = "linear-gradient(var(--gradient-angle, 180deg), var(--spirit-color-gradient-primary-color-01, #eae3ff) 0%, var(--spirit-color-gradient-primary-color-02, #cebcff) 100%)", k = "linear-gradient(var(--gradient-angle, 180deg), var(--spirit-color-gradient-secondary-color-01, #fff) 0%, var(--spirit-color-gradient-secondary-color-02, #a7d9e2) 100%)", h = "linear-gradient(var(--gradient-angle, 135deg), var(--spirit-color-gradient-skeleton-color-01, #e5e5e5) 33%, var(--spirit-color-gradient-skeleton-color-02, #fff) 48.5%, var(--spirit-color-gradient-skeleton-color-03, #e5e5e5) 66%)", If = {
  basicOverlay: y,
  primary: $,
  secondary: k,
  skeleton: h
}, H = "16px", C = "32px", F = "32px", D = "480px", I = "640px", x = "768px", P = "1024px", A = "1280px", W = "1280px", T = "16px", z = "32px", w = "32px", U = "12", xf = "spirit-", Pf = {
  padding: {
    mobile: H,
    tablet: C,
    desktop: F
  },
  xsmall: {
    maxWidth: D
  },
  small: {
    maxWidth: I
  },
  medium: {
    maxWidth: x
  },
  large: {
    maxWidth: P
  },
  maxWidth: A,
  xlarge: {
    maxWidth: W
  }
}, Af = {
  spacing: {
    mobile: T,
    desktop: z,
    tablet: w
  },
  columns: U
}, R = 0, M = "2px", L = "4px", O = "8px", X = "12px", _ = "16px", V = "9999px", Wf = {
  0: R,
  100: M,
  200: L,
  300: O,
  400: X,
  500: _,
  full: V
}, j = "0 0 0 2px var(--spirit-color-focus-focus-ring-color-01, #d2c2ffb2)", q = "0 2px 8px 0 var(--spirit-color-shadow-shadow-100-color-01, #0000001a)", E = "0 4px 12px 0 var(--spirit-color-shadow-shadow-200-color-01, #0003)", G = "0 8px 24px 0 var(--spirit-color-shadow-shadow-300-color-01, #00000040)", J = "0 12px 32px 0 var(--spirit-color-shadow-shadow-400-color-01, #00000040)", Tf = {
  focusRing: j
}, zf = {
  100: q,
  200: E,
  300: G,
  400: J
}, K = 0, N = "1px", Q = "2px", Y = "4px", Z = "6px", tt = "8px", et = "12px", ot = "16px", nt = "20px", at = "24px", rt = "32px", ct = "40px", it = "48px", st = "56px", lt = "64px", dt = "72px", ft = "80px", mt = "96px", wf = {
  0: K,
  100: N,
  200: Q,
  300: Y,
  400: Z,
  500: tt,
  600: et,
  700: ot,
  800: nt,
  900: at,
  1e3: rt,
  1100: ct,
  1200: it,
  1300: st,
  1400: lt,
  1500: dt,
  1600: ft,
  1700: mt
}, St = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, ut = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, gt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, pt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, vt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, bt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Bt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, yt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, $t = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, kt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, ht = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Ht = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, Ct = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, Ft = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Dt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, It = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, xt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, Pt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, At = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Wt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, Tt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  }
}, zt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, wt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Ut = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  }
}, Rt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.3
  }
}, Mt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.3
  }
}, Lt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.3
  }
}, Ot = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.3
  }
}, Xt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  }
}, _t = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Vt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, jt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  }
}, qt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  }
}, Et = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Gt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Jt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  }
}, Kt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  }
}, Nt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Qt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Yt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  }
}, Uf = {
  bodyLargeBold: St,
  bodyLargeItalic: ut,
  bodyLargeRegular: gt,
  bodyLargeSemibold: pt,
  bodyMediumBold: vt,
  bodyMediumItalic: bt,
  bodyMediumRegular: Bt,
  bodyMediumSemibold: yt,
  bodySmallBold: $t,
  bodySmallItalic: kt,
  bodySmallRegular: ht,
  bodySmallSemibold: Ht,
  bodyXlargeBold: Ct,
  bodyXlargeItalic: Ft,
  bodyXlargeRegular: Dt,
  bodyXlargeSemibold: It,
  bodyXsmallBold: xt,
  bodyXsmallItalic: Pt,
  bodyXsmallRegular: At,
  bodyXsmallSemibold: Wt,
  headingLargeBold: Tt,
  headingLargeItalic: zt,
  headingLargeRegular: wt,
  headingLargeSemibold: Ut,
  headingMediumBold: Rt,
  headingMediumItalic: Mt,
  headingMediumRegular: Lt,
  headingMediumSemibold: Ot,
  headingSmallBold: Xt,
  headingSmallItalic: _t,
  headingSmallRegular: Vt,
  headingSmallSemibold: jt,
  headingXlargeBold: qt,
  headingXlargeItalic: Et,
  headingXlargeRegular: Gt,
  headingXlargeSemibold: Jt,
  headingXsmallBold: Kt,
  headingXsmallItalic: Nt,
  headingXsmallRegular: Qt,
  headingXsmallSemibold: Yt
}, Zt = "#d80090", te = "#fdf2f9", ee = "#8d005e", oe = "#f7cce9", ne = "#d80090", ae = "#fbe5f4", re = "#ad0073", ce = "#d80090", ie = "#c30082", se = "#7847ff", le = "#f8f6ff", de = "#7847ff", fe = "#e4daff", me = "#6039cc", Se = "#f1edff", ue = "#936cff", ge = "#ae91ff", pe = "#a07eff", ve = "#1a1b1b80", be = "#f1edff", Be = "#fff0", ye = "#f8f6ff", $e = "#fdfdfc", ke = "#f4f4f4", he = "#f1edff", He = "#d9d9d9", Ce = "#7847ff", Fe = "#a5a5a5", De = "#bfbfbf", Ie = "#b2b2b2", xe = "#7847ff", Pe = "#fff0", Ae = "#6039cc", We = "#e4daff", Te = "#fff0", ze = "#f1edff", we = "#4e2ea6", Ue = "#fdfdfc", Re = "#6039cc", Me = "#7847ff", Le = "#6c40e5", Oe = "#7847ff", Xe = "#6039cc", _e = "#e4daff", Ve = "#fdfdfc", je = "#f1edff", qe = "#e5e5e5", Ee = "#202020", Ge = "#d9d9d9", Je = "#f4f4f4", Ke = "#e5e5e5", Ne = "#fdfdfc", Qe = "#e5e5e5", Ye = "#f1edff", Ze = "#fff0", to = "#f8f6ff", eo = "#f8f6ff", oo = "#4e2ea6", no = "#404040", ao = "#6039cc", ro = "#6039cc", co = "#ffbe00", io = "#e4daff", so = "#7847ff", lo = "#fdfdfc", fo = "#6039cc", mo = "#7847ff", So = "#6c40e5", uo = "#d9d9d9", go = "#535353", po = "#f4f4f4", vo = "#fdfdfc", bo = "#f9f9f9", Bo = "#f2f7fd", yo = "#80b2eb", $o = "#00428c", ko = "#327c3f", ho = "#fdfdfc", Ho = "#3e9b4f", Co = "#327c3f", Fo = "#388b47", Do = "#a5a5a5", Io = "#404040", xo = "#f4f4f4", Po = "#fdfdfc", Ao = "#f9f9f9", Wo = "#f9f9f9", To = "#e5e5e5", zo = "#a5a5a5", wo = "#d9d9d9", Uo = "#b60000", Ro = "#fef2f2", Mo = "#b60000", Lo = "#f18080", Oo = "#940000", Xo = "#fdfdfc", _o = "#e40000", Vo = "#b60000", jo = "#cd0000", qo = "#0052ad", Eo = "#f2f7fd", Go = "#0052ad", Jo = "#80b2eb", Ko = "#00428c", No = "#fdfdfc", Qo = "#0066d8", Yo = "#0052ad", Zo = "#005cc2", tn = "#327c3f", en = "#f5faf6", on = "#327c3f", nn = "#9ecda7", an = "#286533", rn = "#fdfdfc", cn = "#3e9b4f", sn = "#327c3f", ln = "#388b47", dn = "#c26400", fn = "#fef8f2", mn = "#c26400", Sn = "#f9be80", un = "#9d5100", gn = "#fdfdfc", pn = "#f27d00", vn = "#c26400", bn = "#da7100", Bn = "#d2c2ffb2", yn = "#b60000", $n = "#fdfdfc", kn = "#fdfdfc", hn = "#f9f9f9", Hn = "#7f7f7f", Cn = "#a5a5a5", Fn = "#999", Dn = "#7847ff", In = "#202020", xn = "#666", Pn = "#535353", An = "#202020", Wn = "#327c3f", Tn = "#c26400", zn = "#fff", wn = "#fff0", Un = "#eae3ff", Rn = "#cebcff", Mn = "#fff", Ln = "#a7d9e2", On = "#e5e5e5", Xn = "#fff", _n = "#e5e5e5", Vn = "#3c2480", jn = "#6039cc", qn = "#4e2ea6", En = "#3c2480", Gn = "#535353", Jn = "#4e2ea6", Kn = "#3c2480", Nn = "#3c2480", Qn = "#7f7f7f", Yn = "#4e2ea6", Zn = "#202020", ta = "#f4f4f4", ea = "#202020", oa = "#bfbfbf", na = "#202020", aa = "#fdfdfc", ra = "#535353", ca = "#202020", ia = "#404040", sa = "#7847ff", la = "#fdfdfc", da = "#6039cc", fa = "#7847ff", ma = "#6c40e5", Sa = "#0000001a", ua = "#0003", ga = "#00000040", pa = "#00000040", va = "#202020", ba = "#535353", Ba = "#7f7f7f", ya = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accent01BackgroundBasic: Zt,
  accent01BackgroundSubtle: te,
  accent01BorderBasic: ee,
  accent01BorderSubtle: oe,
  accent01ContentBasic: ne,
  accent01ContentSubtle: ae,
  accent01StateActive: re,
  accent01StateDefault: ce,
  accent01StateHover: ie,
  accent02BackgroundBasic: se,
  accent02BackgroundSubtle: le,
  accent02BorderBasic: de,
  accent02BorderSubtle: fe,
  accent02ContentBasic: me,
  accent02ContentSubtle: Se,
  accent02StateActive: ue,
  accent02StateDefault: ge,
  accent02StateHover: pe,
  backgroundBackdrop: ve,
  backgroundInteractiveStateActive: be,
  backgroundInteractiveStateDefault: Be,
  backgroundInteractiveStateHover: ye,
  backgroundPrimary: $e,
  backgroundSecondary: ke,
  backgroundTertiary: he,
  borderBasic: He,
  borderFocus: Ce,
  borderInteractiveStateActive: Fe,
  borderInteractiveStateDefault: De,
  borderInteractiveStateHover: Ie,
  borderInteractiveStateSelected: xe,
  componentButtonPlainBorder: Pe,
  componentButtonPlainContent: Ae,
  componentButtonPlainStateActive: We,
  componentButtonPlainStateDefault: Te,
  componentButtonPlainStateHover: ze,
  componentButtonPrimaryBorder: we,
  componentButtonPrimaryContent: Ue,
  componentButtonPrimaryStateActive: Re,
  componentButtonPrimaryStateDefault: Me,
  componentButtonPrimaryStateHover: Le,
  componentButtonSecondaryBorder: Oe,
  componentButtonSecondaryContent: Xe,
  componentButtonSecondaryStateActive: _e,
  componentButtonSecondaryStateDefault: Ve,
  componentButtonSecondaryStateHover: je,
  componentButtonTertiaryBorder: qe,
  componentButtonTertiaryContent: Ee,
  componentButtonTertiaryStateActive: Ge,
  componentButtonTertiaryStateDefault: Je,
  componentButtonTertiaryStateHover: Ke,
  componentHeaderBackground: Ne,
  componentHeaderBorder: Qe,
  componentHeaderItemBackgroundStateActive: Ye,
  componentHeaderItemBackgroundStateDefault: Ze,
  componentHeaderItemBackgroundStateHover: to,
  componentHeaderItemBackgroundStateSelected: eo,
  componentHeaderItemStateActive: oo,
  componentHeaderItemStateDefault: no,
  componentHeaderItemStateHover: ao,
  componentHeaderItemStateSelected: ro,
  componentHeaderStripeStateSelected: co,
  componentHeaderStripeStateUnselected: io,
  componentPaginationSelectedBorder: so,
  componentPaginationSelectedContent: lo,
  componentPaginationSelectedStateActive: fo,
  componentPaginationSelectedStateDefault: mo,
  componentPaginationSelectedStateHover: So,
  componentPaginationUnselectedBorder: uo,
  componentPaginationUnselectedContent: go,
  componentPaginationUnselectedStateActive: po,
  componentPaginationUnselectedStateDefault: vo,
  componentPaginationUnselectedStateHover: bo,
  componentPricingBoxBackground: Bo,
  componentPricingBoxBorder: yo,
  componentPricingBoxContent: $o,
  componentToggleSelectedBorder: ko,
  componentToggleSelectedContent: ho,
  componentToggleSelectedStateActive: Ho,
  componentToggleSelectedStateDefault: Co,
  componentToggleSelectedStateHover: Fo,
  componentToggleUnselectedBorder: Do,
  componentToggleUnselectedContent: Io,
  componentToggleUnselectedStateActive: xo,
  componentToggleUnselectedStateDefault: Po,
  componentToggleUnselectedStateHover: Ao,
  disabledBackground: Wo,
  disabledBorder: To,
  disabledContent: zo,
  disabledForeground: wo,
  emotionDangerBackgroundBasic: Uo,
  emotionDangerBackgroundSubtle: Ro,
  emotionDangerBorderBasic: Mo,
  emotionDangerBorderSubtle: Lo,
  emotionDangerContentBasic: Oo,
  emotionDangerContentSubtle: Xo,
  emotionDangerStateActive: _o,
  emotionDangerStateDefault: Vo,
  emotionDangerStateHover: jo,
  emotionInformativeBackgroundBasic: qo,
  emotionInformativeBackgroundSubtle: Eo,
  emotionInformativeBorderBasic: Go,
  emotionInformativeBorderSubtle: Jo,
  emotionInformativeContentBasic: Ko,
  emotionInformativeContentSubtle: No,
  emotionInformativeStateActive: Qo,
  emotionInformativeStateDefault: Yo,
  emotionInformativeStateHover: Zo,
  emotionSuccessBackgroundBasic: tn,
  emotionSuccessBackgroundSubtle: en,
  emotionSuccessBorderBasic: on,
  emotionSuccessBorderSubtle: nn,
  emotionSuccessContentBasic: an,
  emotionSuccessContentSubtle: rn,
  emotionSuccessStateActive: cn,
  emotionSuccessStateDefault: sn,
  emotionSuccessStateHover: ln,
  emotionWarningBackgroundBasic: dn,
  emotionWarningBackgroundSubtle: fn,
  emotionWarningBorderBasic: mn,
  emotionWarningBorderSubtle: Sn,
  emotionWarningContentBasic: un,
  emotionWarningContentSubtle: gn,
  emotionWarningStateActive: pn,
  emotionWarningStateDefault: vn,
  emotionWarningStateHover: bn,
  focusFocusRingColor01: Bn,
  formFieldDanger: yn,
  formFieldFilledBackgroundStateActive: $n,
  formFieldFilledBackgroundStateDefault: kn,
  formFieldFilledBackgroundStateHover: hn,
  formFieldFilledBorderStateActive: Hn,
  formFieldFilledBorderStateDefault: Cn,
  formFieldFilledBorderStateHover: Fn,
  formFieldFilledBorderStateSelected: Dn,
  formFieldFilledContent: In,
  formFieldFilledPlaceholder: xn,
  formFieldHelperText: Pn,
  formFieldLabel: An,
  formFieldSuccess: Wn,
  formFieldWarning: Tn,
  gradientBasicOverlayColor01: zn,
  gradientBasicOverlayColor02: wn,
  gradientPrimaryColor01: Un,
  gradientPrimaryColor02: Rn,
  gradientSecondaryColor01: Mn,
  gradientSecondaryColor02: Ln,
  gradientSkeletonColor01: On,
  gradientSkeletonColor02: Xn,
  gradientSkeletonColor03: _n,
  linkPrimaryStateActive: Vn,
  linkPrimaryStateDefault: jn,
  linkPrimaryStateHover: qn,
  linkSecondaryStateActive: En,
  linkSecondaryStateDefault: Gn,
  linkSecondaryStateHover: Jn,
  linkStateVisited: Kn,
  linkTertiaryStateActive: Nn,
  linkTertiaryStateDefault: Qn,
  linkTertiaryStateHover: Yn,
  neutralBackgroundBasic: Zn,
  neutralBackgroundSubtle: ta,
  neutralBorderBasic: ea,
  neutralBorderSubtle: oa,
  neutralContentBasic: na,
  neutralContentSubtle: aa,
  neutralStateActive: ra,
  neutralStateDefault: ca,
  neutralStateHover: ia,
  selectedContentBasic: sa,
  selectedContentSubtle: la,
  selectedStateActive: da,
  selectedStateDefault: fa,
  selectedStateHover: ma,
  shadowShadow100Color01: Sa,
  shadowShadow200Color01: ua,
  shadowShadow300Color01: ga,
  shadowShadow400Color01: pa,
  textPrimary: va,
  textSecondary: ba,
  textTertiary: Ba
}, Symbol.toStringTag, { value: "Module" })), $a = "#d80090", ka = "#fdf2f9", ha = "#8d005e", Ha = "#f7cce9", Ca = "#d80090", Fa = "#fbe5f4", Da = "#ad0073", Ia = "#d80090", xa = "#c30082", Pa = "#7847ff", Aa = "#f8f6ff", Wa = "#7847ff", Ta = "#e4daff", za = "#6039cc", wa = "#f1edff", Ua = "#936cff", Ra = "#ae91ff", Ma = "#a07eff", La = "#1a1b1b80", Oa = "#ffffff1a", Xa = "#fff0", _a = "#ffffff0d", Va = "#6039cc", ja = "#3c2480", qa = "#1e1240", Ea = "#a07eff", Ga = "#1e1240", Ja = "#bba3ff", Ka = "#a07eff", Na = "#ae91ff", Qa = "#ffbe00", Ya = "#fff0", Za = "#fff", tr = "#ffffff26", er = "#fff0", or = "#ffffff1a", nr = "#1e1240", ar = "#3c2480", rr = "#e4daff", cr = "#fff", ir = "#f1edff", sr = "#f8f6ff", lr = "#fff", dr = "#1a1b1b26", fr = "#1a1b1b00", mr = "#1a1b1b1a", Sr = "#1a1b1b00", ur = "#fff", gr = "#1a1b1b4d", pr = "#1a1b1b33", vr = "#1a1b1b40", br = "#6039cc", Br = "#936cff", yr = "#1a1b1b26", $r = "#fff0", kr = "#1a1b1b1a", hr = "#4e2ea6", Hr = "#e5e5e5", Cr = "#fff", Fr = "#f2f2f2", Dr = "#fff", Ir = "#fff", xr = "#ffffff40", Pr = "#fff", Ar = "#6039cc", Wr = "#c9b5ff", Tr = "#f8f6ff", zr = "#e4daff", wr = "#f8f6ff", Ur = "#f8f6ff", Rr = "#7847ff", Mr = "#6039cc", Lr = "#6c40e5", Or = "#4e2ea6", Xr = "#e4daff", _r = "#ffcb33", Vr = "#a07eff", jr = "#fff", qr = "#3e9b4f", Er = "#327c3f", Gr = "#388b47", Jr = "#a07eff", Kr = "#4e2ea6", Nr = "#e4daff", Qr = "#fff", Yr = "#f1edff", Zr = "#ffffff1a", tc = "#fff3", ec = "#ffffff80", oc = "#fff3", nc = "#e40000", ac = "#fce5e5", rc = "#e93333", cc = "#ef6666", ic = "#720000", sc = "#fff", lc = "#ec4d4d", dc = "#e40000", fc = "#e93333", mc = "#0066d8", Sc = "#e5f0fb", uc = "#3385e0", gc = "#66a3e8", pc = "#00336c", vc = "#fff", bc = "#4d94e4", Bc = "#0066d8", yc = "#3385e0", $c = "#3e9b4f", kc = "#ecf5ed", hc = "#65af72", Hc = "#8bc395", Cc = "#1f4e28", Fc = "#fff", Dc = "#78b984", Ic = "#3e9b4f", xc = "#65af72", Pc = "#f27d00", Ac = "#fef2e5", Wc = "#f59733", Tc = "#f7b166", zc = "#793f00", wc = "#fff", Uc = "#f6a44d", Rc = "#f27d00", Mc = "#f59733", Lc = "#d2c2ffb2", Oc = "#ec4d4d", Xc = "#fff", _c = "#f9f9f9", Vc = "#f1edff", jc = "#936cff", qc = "#ae91ff", Ec = "#a07eff", Gc = "#ffbe00", Jc = "#202020", Kc = "#666", Nc = "#c9b5ff", Qc = "#fff", Yc = "#78b984", Zc = "#f6a44d", ti = "#606060", ei = "#60606000", oi = "#7847ff", ni = "#482b99", ai = "#35818e", ri = "#482b99", ci = "#6c40e5", ii = "#936cff", si = "#6c40e5", li = "#e5e5e5", di = "#fff", fi = "#f2f2f2", mi = "#e5e5e5", Si = "#d6c8ff", ui = "#f2f2f2", gi = "#ffbe00", pi = "#e5e5e5", vi = "#bba3ff", bi = "#f2f2f2", Bi = "#202020", yi = "#f2f2f2", $i = "#202020", ki = "#bfbfbf", hi = "#202020", Hi = "#fff", Ci = "#535353", Fi = "#202020", Di = "#404040", Ii = "#fff", xi = "#3c2480", Pi = "#ffd24d", Ai = "#ffbe00", Wi = "#ffcb33", Ti = "#00000026", zi = "#0003", wi = "#00000040", Ui = "#00000040", Ri = "#f9f9f9", Mi = "#d9d9d9", Li = "#b2b2b2", Oi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accent01BackgroundBasic: $a,
  accent01BackgroundSubtle: ka,
  accent01BorderBasic: ha,
  accent01BorderSubtle: Ha,
  accent01ContentBasic: Ca,
  accent01ContentSubtle: Fa,
  accent01StateActive: Da,
  accent01StateDefault: Ia,
  accent01StateHover: xa,
  accent02BackgroundBasic: Pa,
  accent02BackgroundSubtle: Aa,
  accent02BorderBasic: Wa,
  accent02BorderSubtle: Ta,
  accent02ContentBasic: za,
  accent02ContentSubtle: wa,
  accent02StateActive: Ua,
  accent02StateDefault: Ra,
  accent02StateHover: Ma,
  backgroundBackdrop: La,
  backgroundInteractiveStateActive: Oa,
  backgroundInteractiveStateDefault: Xa,
  backgroundInteractiveStateHover: _a,
  backgroundPrimary: Va,
  backgroundSecondary: ja,
  backgroundTertiary: qa,
  borderBasic: Ea,
  borderFocus: Ga,
  borderInteractiveStateActive: Ja,
  borderInteractiveStateDefault: Ka,
  borderInteractiveStateHover: Na,
  borderInteractiveStateSelected: Qa,
  componentButtonPlainBorder: Ya,
  componentButtonPlainContent: Za,
  componentButtonPlainStateActive: tr,
  componentButtonPlainStateDefault: er,
  componentButtonPlainStateHover: or,
  componentButtonPrimaryBorder: nr,
  componentButtonPrimaryContent: ar,
  componentButtonPrimaryStateActive: rr,
  componentButtonPrimaryStateDefault: cr,
  componentButtonPrimaryStateHover: ir,
  componentButtonSecondaryBorder: sr,
  componentButtonSecondaryContent: lr,
  componentButtonSecondaryStateActive: dr,
  componentButtonSecondaryStateDefault: fr,
  componentButtonSecondaryStateHover: mr,
  componentButtonTertiaryBorder: Sr,
  componentButtonTertiaryContent: ur,
  componentButtonTertiaryStateActive: gr,
  componentButtonTertiaryStateDefault: pr,
  componentButtonTertiaryStateHover: vr,
  componentHeaderBackground: br,
  componentHeaderBorder: Br,
  componentHeaderItemBackgroundStateActive: yr,
  componentHeaderItemBackgroundStateDefault: $r,
  componentHeaderItemBackgroundStateHover: kr,
  componentHeaderItemBackgroundStateSelected: hr,
  componentHeaderItemStateActive: Hr,
  componentHeaderItemStateDefault: Cr,
  componentHeaderItemStateHover: Fr,
  componentHeaderItemStateSelected: Dr,
  componentHeaderStripeStateSelected: Ir,
  componentHeaderStripeStateUnselected: xr,
  componentPaginationSelectedBorder: Pr,
  componentPaginationSelectedContent: Ar,
  componentPaginationSelectedStateActive: Wr,
  componentPaginationSelectedStateDefault: Tr,
  componentPaginationSelectedStateHover: zr,
  componentPaginationUnselectedBorder: wr,
  componentPaginationUnselectedContent: Ur,
  componentPaginationUnselectedStateActive: Rr,
  componentPaginationUnselectedStateDefault: Mr,
  componentPaginationUnselectedStateHover: Lr,
  componentPricingBoxBackground: Or,
  componentPricingBoxBorder: Xr,
  componentPricingBoxContent: _r,
  componentToggleSelectedBorder: Vr,
  componentToggleSelectedContent: jr,
  componentToggleSelectedStateActive: qr,
  componentToggleSelectedStateDefault: Er,
  componentToggleSelectedStateHover: Gr,
  componentToggleUnselectedBorder: Jr,
  componentToggleUnselectedContent: Kr,
  componentToggleUnselectedStateActive: Nr,
  componentToggleUnselectedStateDefault: Qr,
  componentToggleUnselectedStateHover: Yr,
  disabledBackground: Zr,
  disabledBorder: tc,
  disabledContent: ec,
  disabledForeground: oc,
  emotionDangerBackgroundBasic: nc,
  emotionDangerBackgroundSubtle: ac,
  emotionDangerBorderBasic: rc,
  emotionDangerBorderSubtle: cc,
  emotionDangerContentBasic: ic,
  emotionDangerContentSubtle: sc,
  emotionDangerStateActive: lc,
  emotionDangerStateDefault: dc,
  emotionDangerStateHover: fc,
  emotionInformativeBackgroundBasic: mc,
  emotionInformativeBackgroundSubtle: Sc,
  emotionInformativeBorderBasic: uc,
  emotionInformativeBorderSubtle: gc,
  emotionInformativeContentBasic: pc,
  emotionInformativeContentSubtle: vc,
  emotionInformativeStateActive: bc,
  emotionInformativeStateDefault: Bc,
  emotionInformativeStateHover: yc,
  emotionSuccessBackgroundBasic: $c,
  emotionSuccessBackgroundSubtle: kc,
  emotionSuccessBorderBasic: hc,
  emotionSuccessBorderSubtle: Hc,
  emotionSuccessContentBasic: Cc,
  emotionSuccessContentSubtle: Fc,
  emotionSuccessStateActive: Dc,
  emotionSuccessStateDefault: Ic,
  emotionSuccessStateHover: xc,
  emotionWarningBackgroundBasic: Pc,
  emotionWarningBackgroundSubtle: Ac,
  emotionWarningBorderBasic: Wc,
  emotionWarningBorderSubtle: Tc,
  emotionWarningContentBasic: zc,
  emotionWarningContentSubtle: wc,
  emotionWarningStateActive: Uc,
  emotionWarningStateDefault: Rc,
  emotionWarningStateHover: Mc,
  focusFocusRingColor01: Lc,
  formFieldDanger: Oc,
  formFieldFilledBackgroundStateActive: Xc,
  formFieldFilledBackgroundStateDefault: _c,
  formFieldFilledBackgroundStateHover: Vc,
  formFieldFilledBorderStateActive: jc,
  formFieldFilledBorderStateDefault: qc,
  formFieldFilledBorderStateHover: Ec,
  formFieldFilledBorderStateSelected: Gc,
  formFieldFilledContent: Jc,
  formFieldFilledPlaceholder: Kc,
  formFieldHelperText: Nc,
  formFieldLabel: Qc,
  formFieldSuccess: Yc,
  formFieldWarning: Zc,
  gradientBasicOverlayColor01: ti,
  gradientBasicOverlayColor02: ei,
  gradientPrimaryColor01: oi,
  gradientPrimaryColor02: ni,
  gradientSecondaryColor01: ai,
  gradientSecondaryColor02: ri,
  gradientSkeletonColor01: ci,
  gradientSkeletonColor02: ii,
  gradientSkeletonColor03: si,
  linkPrimaryStateActive: li,
  linkPrimaryStateDefault: di,
  linkPrimaryStateHover: fi,
  linkSecondaryStateActive: mi,
  linkSecondaryStateDefault: Si,
  linkSecondaryStateHover: ui,
  linkStateVisited: gi,
  linkTertiaryStateActive: pi,
  linkTertiaryStateDefault: vi,
  linkTertiaryStateHover: bi,
  neutralBackgroundBasic: Bi,
  neutralBackgroundSubtle: yi,
  neutralBorderBasic: $i,
  neutralBorderSubtle: ki,
  neutralContentBasic: hi,
  neutralContentSubtle: Hi,
  neutralStateActive: Ci,
  neutralStateDefault: Fi,
  neutralStateHover: Di,
  selectedContentBasic: Ii,
  selectedContentSubtle: xi,
  selectedStateActive: Pi,
  selectedStateDefault: Ai,
  selectedStateHover: Wi,
  shadowShadow100Color01: Ti,
  shadowShadow200Color01: zi,
  shadowShadow300Color01: wi,
  shadowShadow400Color01: Ui,
  textPrimary: Ri,
  textSecondary: Mi,
  textTertiary: Li
}, Symbol.toStringTag, { value: "Module" })), Xi = "var(--spirit-color-accent-01-background-basic)", _i = "var(--spirit-color-accent-01-background-subtle)", Vi = "var(--spirit-color-accent-01-border-basic)", ji = "var(--spirit-color-accent-01-border-subtle)", qi = "var(--spirit-color-accent-01-content-basic)", Ei = "var(--spirit-color-accent-01-content-subtle)", Gi = "var(--spirit-color-accent-01-state-active)", Ji = "var(--spirit-color-accent-01-state-default)", Ki = "var(--spirit-color-accent-01-state-hover)", Ni = "var(--spirit-color-accent-02-background-basic)", Qi = "var(--spirit-color-accent-02-background-subtle)", Yi = "var(--spirit-color-accent-02-border-basic)", Zi = "var(--spirit-color-accent-02-border-subtle)", ts = "var(--spirit-color-accent-02-content-basic)", es = "var(--spirit-color-accent-02-content-subtle)", os = "var(--spirit-color-accent-02-state-active)", ns = "var(--spirit-color-accent-02-state-default)", as = "var(--spirit-color-accent-02-state-hover)", rs = "var(--spirit-color-background-backdrop)", cs = "var(--spirit-color-background-interactive-state-active)", is = "var(--spirit-color-background-interactive-state-default)", ss = "var(--spirit-color-background-interactive-state-hover)", ls = "var(--spirit-color-background-primary)", ds = "var(--spirit-color-background-secondary)", fs = "var(--spirit-color-background-tertiary)", ms = "var(--spirit-color-border-basic)", Ss = "var(--spirit-color-border-focus)", us = "var(--spirit-color-border-interactive-state-active)", gs = "var(--spirit-color-border-interactive-state-default)", ps = "var(--spirit-color-border-interactive-state-hover)", vs = "var(--spirit-color-border-interactive-state-selected)", bs = "var(--spirit-color-component-button-plain-border)", Bs = "var(--spirit-color-component-button-plain-content)", ys = "var(--spirit-color-component-button-plain-state-active)", $s = "var(--spirit-color-component-button-plain-state-default)", ks = "var(--spirit-color-component-button-plain-state-hover)", hs = "var(--spirit-color-component-button-primary-border)", Hs = "var(--spirit-color-component-button-primary-content)", Cs = "var(--spirit-color-component-button-primary-state-active)", Fs = "var(--spirit-color-component-button-primary-state-default)", Ds = "var(--spirit-color-component-button-primary-state-hover)", Is = "var(--spirit-color-component-button-secondary-border)", xs = "var(--spirit-color-component-button-secondary-content)", Ps = "var(--spirit-color-component-button-secondary-state-active)", As = "var(--spirit-color-component-button-secondary-state-default)", Ws = "var(--spirit-color-component-button-secondary-state-hover)", Ts = "var(--spirit-color-component-button-tertiary-border)", zs = "var(--spirit-color-component-button-tertiary-content)", ws = "var(--spirit-color-component-button-tertiary-state-active)", Us = "var(--spirit-color-component-button-tertiary-state-default)", Rs = "var(--spirit-color-component-button-tertiary-state-hover)", Ms = "var(--spirit-color-component-header-background)", Ls = "var(--spirit-color-component-header-border)", Os = "var(--spirit-color-component-header-item-background-state-active)", Xs = "var(--spirit-color-component-header-item-background-state-default)", _s = "var(--spirit-color-component-header-item-background-state-hover)", Vs = "var(--spirit-color-component-header-item-background-state-selected)", js = "var(--spirit-color-component-header-item-state-active)", qs = "var(--spirit-color-component-header-item-state-default)", Es = "var(--spirit-color-component-header-item-state-hover)", Gs = "var(--spirit-color-component-header-item-state-selected)", Js = "var(--spirit-color-component-header-stripe-state-selected)", Ks = "var(--spirit-color-component-header-stripe-state-unselected)", Ns = "var(--spirit-color-component-pagination-selected-border)", Qs = "var(--spirit-color-component-pagination-selected-content)", Ys = "var(--spirit-color-component-pagination-selected-state-active)", Zs = "var(--spirit-color-component-pagination-selected-state-default)", tl = "var(--spirit-color-component-pagination-selected-state-hover)", el = "var(--spirit-color-component-pagination-unselected-border)", ol = "var(--spirit-color-component-pagination-unselected-content)", nl = "var(--spirit-color-component-pagination-unselected-state-active)", al = "var(--spirit-color-component-pagination-unselected-state-default)", rl = "var(--spirit-color-component-pagination-unselected-state-hover)", cl = "var(--spirit-color-component-pricing-box-background)", il = "var(--spirit-color-component-pricing-box-border)", sl = "var(--spirit-color-component-pricing-box-content)", ll = "var(--spirit-color-component-toggle-selected-border)", dl = "var(--spirit-color-component-toggle-selected-content)", fl = "var(--spirit-color-component-toggle-selected-state-active)", ml = "var(--spirit-color-component-toggle-selected-state-default)", Sl = "var(--spirit-color-component-toggle-selected-state-hover)", ul = "var(--spirit-color-component-toggle-unselected-border)", gl = "var(--spirit-color-component-toggle-unselected-content)", pl = "var(--spirit-color-component-toggle-unselected-state-active)", vl = "var(--spirit-color-component-toggle-unselected-state-default)", bl = "var(--spirit-color-component-toggle-unselected-state-hover)", Bl = "var(--spirit-color-disabled-background)", yl = "var(--spirit-color-disabled-border)", $l = "var(--spirit-color-disabled-content)", kl = "var(--spirit-color-disabled-foreground)", hl = "var(--spirit-color-emotion-danger-background-basic)", Hl = "var(--spirit-color-emotion-danger-background-subtle)", Cl = "var(--spirit-color-emotion-danger-border-basic)", Fl = "var(--spirit-color-emotion-danger-border-subtle)", Dl = "var(--spirit-color-emotion-danger-content-basic)", Il = "var(--spirit-color-emotion-danger-content-subtle)", xl = "var(--spirit-color-emotion-danger-state-active)", Pl = "var(--spirit-color-emotion-danger-state-default)", Al = "var(--spirit-color-emotion-danger-state-hover)", Wl = "var(--spirit-color-emotion-informative-background-basic)", Tl = "var(--spirit-color-emotion-informative-background-subtle)", zl = "var(--spirit-color-emotion-informative-border-basic)", wl = "var(--spirit-color-emotion-informative-border-subtle)", Ul = "var(--spirit-color-emotion-informative-content-basic)", Rl = "var(--spirit-color-emotion-informative-content-subtle)", Ml = "var(--spirit-color-emotion-informative-state-active)", Ll = "var(--spirit-color-emotion-informative-state-default)", Ol = "var(--spirit-color-emotion-informative-state-hover)", Xl = "var(--spirit-color-emotion-success-background-basic)", _l = "var(--spirit-color-emotion-success-background-subtle)", Vl = "var(--spirit-color-emotion-success-border-basic)", jl = "var(--spirit-color-emotion-success-border-subtle)", ql = "var(--spirit-color-emotion-success-content-basic)", El = "var(--spirit-color-emotion-success-content-subtle)", Gl = "var(--spirit-color-emotion-success-state-active)", Jl = "var(--spirit-color-emotion-success-state-default)", Kl = "var(--spirit-color-emotion-success-state-hover)", Nl = "var(--spirit-color-emotion-warning-background-basic)", Ql = "var(--spirit-color-emotion-warning-background-subtle)", Yl = "var(--spirit-color-emotion-warning-border-basic)", Zl = "var(--spirit-color-emotion-warning-border-subtle)", td = "var(--spirit-color-emotion-warning-content-basic)", ed = "var(--spirit-color-emotion-warning-content-subtle)", od = "var(--spirit-color-emotion-warning-state-active)", nd = "var(--spirit-color-emotion-warning-state-default)", ad = "var(--spirit-color-emotion-warning-state-hover)", rd = "var(--spirit-color-focus-focus-ring-color-01)", cd = "var(--spirit-color-form-field-danger)", id = "var(--spirit-color-form-field-filled-background-state-active)", sd = "var(--spirit-color-form-field-filled-background-state-default)", ld = "var(--spirit-color-form-field-filled-background-state-hover)", dd = "var(--spirit-color-form-field-filled-border-state-active)", fd = "var(--spirit-color-form-field-filled-border-state-default)", md = "var(--spirit-color-form-field-filled-border-state-hover)", Sd = "var(--spirit-color-form-field-filled-border-state-selected)", ud = "var(--spirit-color-form-field-filled-content)", gd = "var(--spirit-color-form-field-filled-placeholder)", pd = "var(--spirit-color-form-field-helper-text)", vd = "var(--spirit-color-form-field-label)", bd = "var(--spirit-color-form-field-success)", Bd = "var(--spirit-color-form-field-warning)", yd = "var(--spirit-color-gradient-basic-overlay-color-01)", $d = "var(--spirit-color-gradient-basic-overlay-color-02)", kd = "var(--spirit-color-gradient-primary-color-01)", hd = "var(--spirit-color-gradient-primary-color-02)", Hd = "var(--spirit-color-gradient-secondary-color-01)", Cd = "var(--spirit-color-gradient-secondary-color-02)", Fd = "var(--spirit-color-gradient-skeleton-color-01)", Dd = "var(--spirit-color-gradient-skeleton-color-02)", Id = "var(--spirit-color-gradient-skeleton-color-03)", xd = "var(--spirit-color-link-primary-state-active)", Pd = "var(--spirit-color-link-primary-state-default)", Ad = "var(--spirit-color-link-primary-state-hover)", Wd = "var(--spirit-color-link-secondary-state-active)", Td = "var(--spirit-color-link-secondary-state-default)", zd = "var(--spirit-color-link-secondary-state-hover)", wd = "var(--spirit-color-link-state-visited)", Ud = "var(--spirit-color-link-tertiary-state-active)", Rd = "var(--spirit-color-link-tertiary-state-default)", Md = "var(--spirit-color-link-tertiary-state-hover)", Ld = "var(--spirit-color-neutral-background-basic)", Od = "var(--spirit-color-neutral-background-subtle)", Xd = "var(--spirit-color-neutral-border-basic)", _d = "var(--spirit-color-neutral-border-subtle)", Vd = "var(--spirit-color-neutral-content-basic)", jd = "var(--spirit-color-neutral-content-subtle)", qd = "var(--spirit-color-neutral-state-active)", Ed = "var(--spirit-color-neutral-state-default)", Gd = "var(--spirit-color-neutral-state-hover)", Jd = "var(--spirit-color-selected-content-basic)", Kd = "var(--spirit-color-selected-content-subtle)", Nd = "var(--spirit-color-selected-state-active)", Qd = "var(--spirit-color-selected-state-default)", Yd = "var(--spirit-color-selected-state-hover)", Zd = "var(--spirit-color-shadow-shadow-100-color-01)", tf = "var(--spirit-color-shadow-shadow-200-color-01)", ef = "var(--spirit-color-shadow-shadow-300-color-01)", of = "var(--spirit-color-shadow-shadow-400-color-01)", nf = "var(--spirit-color-text-primary)", af = "var(--spirit-color-text-secondary)", rf = "var(--spirit-color-text-tertiary)", cf = {
  "01": {
    backgroundBasic: Xi,
    backgroundSubtle: _i,
    borderBasic: Vi,
    borderSubtle: ji,
    contentBasic: qi,
    contentSubtle: Ei,
    stateActive: Gi,
    stateDefault: Ji,
    stateHover: Ki
  },
  "02": {
    backgroundBasic: Ni,
    backgroundSubtle: Qi,
    borderBasic: Yi,
    borderSubtle: Zi,
    contentBasic: ts,
    contentSubtle: es,
    stateActive: os,
    stateDefault: ns,
    stateHover: as
  }
}, sf = {
  backdrop: rs,
  interactive: {
    stateActive: cs,
    stateDefault: is,
    stateHover: ss
  },
  primary: ls,
  secondary: ds,
  tertiary: fs
}, lf = {
  basic: ms,
  focus: Ss,
  interactive: {
    stateActive: us,
    stateDefault: gs,
    stateHover: ps,
    stateSelected: vs
  }
}, df = {
  button: {
    plain: {
      border: bs,
      content: Bs,
      stateActive: ys,
      stateDefault: $s,
      stateHover: ks
    },
    primary: {
      border: hs,
      content: Hs,
      stateActive: Cs,
      stateDefault: Fs,
      stateHover: Ds
    },
    secondary: {
      border: Is,
      content: xs,
      stateActive: Ps,
      stateDefault: As,
      stateHover: Ws
    },
    tertiary: {
      border: Ts,
      content: zs,
      stateActive: ws,
      stateDefault: Us,
      stateHover: Rs
    }
  },
  header: {
    background: Ms,
    border: Ls,
    itemBackgroundStateActive: Os,
    itemBackgroundStateDefault: Xs,
    itemBackgroundStateHover: _s,
    itemBackgroundStateSelected: Vs,
    itemStateActive: js,
    itemStateDefault: qs,
    itemStateHover: Es,
    itemStateSelected: Gs,
    stripeStateSelected: Js,
    stripeStateUnselected: Ks
  },
  pagination: {
    selectedBorder: Ns,
    selectedContent: Qs,
    selectedStateActive: Ys,
    selectedStateDefault: Zs,
    selectedStateHover: tl,
    unselectedBorder: el,
    unselectedContent: ol,
    unselectedStateActive: nl,
    unselectedStateDefault: al,
    unselectedStateHover: rl
  },
  pricingBox: {
    background: cl,
    border: il,
    content: sl
  },
  toggle: {
    selectedBorder: ll,
    selectedContent: dl,
    selectedStateActive: fl,
    selectedStateDefault: ml,
    selectedStateHover: Sl,
    unselectedBorder: ul,
    unselectedContent: gl,
    unselectedStateActive: pl,
    unselectedStateDefault: vl,
    unselectedStateHover: bl
  }
}, ff = {
  background: Bl,
  border: yl,
  content: $l,
  foreground: kl
}, mf = {
  danger: {
    backgroundBasic: hl,
    backgroundSubtle: Hl,
    borderBasic: Cl,
    borderSubtle: Fl,
    contentBasic: Dl,
    contentSubtle: Il,
    stateActive: xl,
    stateDefault: Pl,
    stateHover: Al
  },
  informative: {
    backgroundBasic: Wl,
    backgroundSubtle: Tl,
    borderBasic: zl,
    borderSubtle: wl,
    contentBasic: Ul,
    contentSubtle: Rl,
    stateActive: Ml,
    stateDefault: Ll,
    stateHover: Ol
  },
  success: {
    backgroundBasic: Xl,
    backgroundSubtle: _l,
    borderBasic: Vl,
    borderSubtle: jl,
    contentBasic: ql,
    contentSubtle: El,
    stateActive: Gl,
    stateDefault: Jl,
    stateHover: Kl
  },
  warning: {
    backgroundBasic: Nl,
    backgroundSubtle: Ql,
    borderBasic: Yl,
    borderSubtle: Zl,
    contentBasic: td,
    contentSubtle: ed,
    stateActive: od,
    stateDefault: nd,
    stateHover: ad
  }
}, Sf = {
  focusRing: {
    color01: rd
  }
}, uf = {
  danger: cd,
  filled: {
    backgroundStateActive: id,
    backgroundStateDefault: sd,
    backgroundStateHover: ld,
    borderStateActive: dd,
    borderStateDefault: fd,
    borderStateHover: md,
    borderStateSelected: Sd,
    content: ud,
    placeholder: gd
  },
  helperText: pd,
  label: vd,
  success: bd,
  warning: Bd
}, gf = {
  basicOverlay: {
    color01: yd,
    color02: $d
  },
  primary: {
    color01: kd,
    color02: hd
  },
  secondary: {
    color01: Hd,
    color02: Cd
  },
  skeleton: {
    color01: Fd,
    color02: Dd,
    color03: Id
  }
}, pf = {
  primary: {
    stateActive: xd,
    stateDefault: Pd,
    stateHover: Ad
  },
  secondary: {
    stateActive: Wd,
    stateDefault: Td,
    stateHover: zd
  },
  stateVisited: wd,
  tertiary: {
    stateActive: Ud,
    stateDefault: Rd,
    stateHover: Md
  }
}, vf = {
  backgroundBasic: Ld,
  backgroundSubtle: Od,
  borderBasic: Xd,
  borderSubtle: _d,
  contentBasic: Vd,
  contentSubtle: jd,
  stateActive: qd,
  stateDefault: Ed,
  stateHover: Gd
}, bf = {
  contentBasic: Jd,
  contentSubtle: Kd,
  stateActive: Nd,
  stateDefault: Qd,
  stateHover: Yd
}, Bf = {
  shadow100: {
    color01: Zd
  },
  shadow200: {
    color01: tf
  },
  shadow300: {
    color01: ef
  },
  shadow400: {
    color01: of
  }
}, yf = {
  primary: nf,
  secondary: af,
  tertiary: rf
}, Rf = {
  accent: cf,
  background: sf,
  border: lf,
  component: df,
  disabled: ff,
  emotion: mf,
  focus: Sf,
  formField: uf,
  gradient: gf,
  link: pf,
  neutral: vf,
  selected: bf,
  shadow: Bf,
  text: yf
}, Mf = {
  themeLightDefault: {
    tokens: ya
  },
  themeLightOnBrand: {
    tokens: Oi
  }
};
export {
  Xi as accent01BackgroundBasic,
  _i as accent01BackgroundSubtle,
  Vi as accent01BorderBasic,
  ji as accent01BorderSubtle,
  qi as accent01ContentBasic,
  Ei as accent01ContentSubtle,
  Gi as accent01StateActive,
  Ji as accent01StateDefault,
  Ki as accent01StateHover,
  Ni as accent02BackgroundBasic,
  Qi as accent02BackgroundSubtle,
  Yi as accent02BorderBasic,
  Zi as accent02BorderSubtle,
  ts as accent02ContentBasic,
  es as accent02ContentSubtle,
  os as accent02StateActive,
  ns as accent02StateDefault,
  as as accent02StateHover,
  cf as accentColors,
  rs as backgroundBackdrop,
  sf as backgroundColors,
  cs as backgroundInteractiveStateActive,
  is as backgroundInteractiveStateDefault,
  ss as backgroundInteractiveStateHover,
  ls as backgroundPrimary,
  ds as backgroundSecondary,
  fs as backgroundTertiary,
  St as bodyLargeBold,
  ut as bodyLargeItalic,
  gt as bodyLargeRegular,
  pt as bodyLargeSemibold,
  vt as bodyMediumBold,
  bt as bodyMediumItalic,
  Bt as bodyMediumRegular,
  yt as bodyMediumSemibold,
  $t as bodySmallBold,
  kt as bodySmallItalic,
  ht as bodySmallRegular,
  Ht as bodySmallSemibold,
  Ct as bodyXlargeBold,
  Ft as bodyXlargeItalic,
  Dt as bodyXlargeRegular,
  It as bodyXlargeSemibold,
  xt as bodyXsmallBold,
  Pt as bodyXsmallItalic,
  At as bodyXsmallRegular,
  Wt as bodyXsmallSemibold,
  ms as borderBasic,
  lf as borderColors,
  Ss as borderFocus,
  us as borderInteractiveStateActive,
  gs as borderInteractiveStateDefault,
  ps as borderInteractiveStateHover,
  vs as borderInteractiveStateSelected,
  Cf as borderWidth0,
  Ff as borderWidth100,
  Df as borderWidth200,
  d as breakpointDesktop,
  $f as breakpointMobile,
  l as breakpointTablet,
  hf as breakpoints,
  v as buttonLargeRadiusDesktop,
  f as buttonLargeRadiusMobile,
  u as buttonLargeRadiusTablet,
  b as buttonMediumRadiusDesktop,
  m as buttonMediumRadiusMobile,
  g as buttonMediumRadiusTablet,
  B as buttonSmallRadiusDesktop,
  S as buttonSmallRadiusMobile,
  p as buttonSmallRadiusTablet,
  Hf as buttons,
  Rf as colors,
  bs as componentButtonPlainBorder,
  Bs as componentButtonPlainContent,
  ys as componentButtonPlainStateActive,
  $s as componentButtonPlainStateDefault,
  ks as componentButtonPlainStateHover,
  hs as componentButtonPrimaryBorder,
  Hs as componentButtonPrimaryContent,
  Cs as componentButtonPrimaryStateActive,
  Fs as componentButtonPrimaryStateDefault,
  Ds as componentButtonPrimaryStateHover,
  Is as componentButtonSecondaryBorder,
  xs as componentButtonSecondaryContent,
  Ps as componentButtonSecondaryStateActive,
  As as componentButtonSecondaryStateDefault,
  Ws as componentButtonSecondaryStateHover,
  Ts as componentButtonTertiaryBorder,
  zs as componentButtonTertiaryContent,
  ws as componentButtonTertiaryStateActive,
  Us as componentButtonTertiaryStateDefault,
  Rs as componentButtonTertiaryStateHover,
  df as componentColors,
  Ms as componentHeaderBackground,
  Ls as componentHeaderBorder,
  Os as componentHeaderItemBackgroundStateActive,
  Xs as componentHeaderItemBackgroundStateDefault,
  _s as componentHeaderItemBackgroundStateHover,
  Vs as componentHeaderItemBackgroundStateSelected,
  js as componentHeaderItemStateActive,
  qs as componentHeaderItemStateDefault,
  Es as componentHeaderItemStateHover,
  Gs as componentHeaderItemStateSelected,
  Js as componentHeaderStripeStateSelected,
  Ks as componentHeaderStripeStateUnselected,
  Ns as componentPaginationSelectedBorder,
  Qs as componentPaginationSelectedContent,
  Ys as componentPaginationSelectedStateActive,
  Zs as componentPaginationSelectedStateDefault,
  tl as componentPaginationSelectedStateHover,
  el as componentPaginationUnselectedBorder,
  ol as componentPaginationUnselectedContent,
  nl as componentPaginationUnselectedStateActive,
  al as componentPaginationUnselectedStateDefault,
  rl as componentPaginationUnselectedStateHover,
  cl as componentPricingBoxBackground,
  il as componentPricingBoxBorder,
  sl as componentPricingBoxContent,
  ll as componentToggleSelectedBorder,
  dl as componentToggleSelectedContent,
  fl as componentToggleSelectedStateActive,
  ml as componentToggleSelectedStateDefault,
  Sl as componentToggleSelectedStateHover,
  ul as componentToggleUnselectedBorder,
  gl as componentToggleUnselectedContent,
  pl as componentToggleUnselectedStateActive,
  vl as componentToggleUnselectedStateDefault,
  bl as componentToggleUnselectedStateHover,
  P as containerLargeMaxWidth,
  A as containerMaxWidth,
  x as containerMediumMaxWidth,
  F as containerPaddingDesktop,
  H as containerPaddingMobile,
  C as containerPaddingTablet,
  I as containerSmallMaxWidth,
  W as containerXlargeMaxWidth,
  D as containerXsmallMaxWidth,
  Pf as containers,
  xf as cssVariablePrefix,
  Bl as disabledBackground,
  yl as disabledBorder,
  ff as disabledColors,
  $l as disabledContent,
  kl as disabledForeground,
  mf as emotionColors,
  hl as emotionDangerBackgroundBasic,
  Hl as emotionDangerBackgroundSubtle,
  Cl as emotionDangerBorderBasic,
  Fl as emotionDangerBorderSubtle,
  Dl as emotionDangerContentBasic,
  Il as emotionDangerContentSubtle,
  xl as emotionDangerStateActive,
  Pl as emotionDangerStateDefault,
  Al as emotionDangerStateHover,
  Wl as emotionInformativeBackgroundBasic,
  Tl as emotionInformativeBackgroundSubtle,
  zl as emotionInformativeBorderBasic,
  wl as emotionInformativeBorderSubtle,
  Ul as emotionInformativeContentBasic,
  Rl as emotionInformativeContentSubtle,
  Ml as emotionInformativeStateActive,
  Ll as emotionInformativeStateDefault,
  Ol as emotionInformativeStateHover,
  Xl as emotionSuccessBackgroundBasic,
  _l as emotionSuccessBackgroundSubtle,
  Vl as emotionSuccessBorderBasic,
  jl as emotionSuccessBorderSubtle,
  ql as emotionSuccessContentBasic,
  El as emotionSuccessContentSubtle,
  Gl as emotionSuccessStateActive,
  Jl as emotionSuccessStateDefault,
  Kl as emotionSuccessStateHover,
  Nl as emotionWarningBackgroundBasic,
  Ql as emotionWarningBackgroundSubtle,
  Yl as emotionWarningBorderBasic,
  Zl as emotionWarningBorderSubtle,
  td as emotionWarningContentBasic,
  ed as emotionWarningContentSubtle,
  od as emotionWarningStateActive,
  nd as emotionWarningStateDefault,
  ad as emotionWarningStateHover,
  Tf as focus,
  Sf as focusColors,
  rd as focusFocusRingColor01,
  j as focusRing,
  uf as formFieldColors,
  cd as formFieldDanger,
  id as formFieldFilledBackgroundStateActive,
  sd as formFieldFilledBackgroundStateDefault,
  ld as formFieldFilledBackgroundStateHover,
  dd as formFieldFilledBorderStateActive,
  fd as formFieldFilledBorderStateDefault,
  md as formFieldFilledBorderStateHover,
  Sd as formFieldFilledBorderStateSelected,
  ud as formFieldFilledContent,
  gd as formFieldFilledPlaceholder,
  pd as formFieldHelperText,
  vd as formFieldLabel,
  c as formFieldLargeRadiusDesktop,
  t as formFieldLargeRadiusMobile,
  n as formFieldLargeRadiusTablet,
  i as formFieldMediumRadiusDesktop,
  e as formFieldMediumRadiusMobile,
  a as formFieldMediumRadiusTablet,
  s as formFieldSmallRadiusDesktop,
  o as formFieldSmallRadiusMobile,
  r as formFieldSmallRadiusTablet,
  bd as formFieldSuccess,
  Bd as formFieldWarning,
  kf as formFields,
  y as gradientBasicOverlay,
  yd as gradientBasicOverlayColor01,
  $d as gradientBasicOverlayColor02,
  gf as gradientColors,
  $ as gradientPrimary,
  kd as gradientPrimaryColor01,
  hd as gradientPrimaryColor02,
  k as gradientSecondary,
  Hd as gradientSecondaryColor01,
  Cd as gradientSecondaryColor02,
  h as gradientSkeleton,
  Fd as gradientSkeletonColor01,
  Dd as gradientSkeletonColor02,
  Id as gradientSkeletonColor03,
  If as gradients,
  U as gridColumns,
  z as gridSpacingDesktop,
  T as gridSpacingMobile,
  w as gridSpacingTablet,
  Af as grids,
  Tt as headingLargeBold,
  zt as headingLargeItalic,
  wt as headingLargeRegular,
  Ut as headingLargeSemibold,
  Rt as headingMediumBold,
  Mt as headingMediumItalic,
  Lt as headingMediumRegular,
  Ot as headingMediumSemibold,
  Xt as headingSmallBold,
  _t as headingSmallItalic,
  Vt as headingSmallRegular,
  jt as headingSmallSemibold,
  qt as headingXlargeBold,
  Et as headingXlargeItalic,
  Gt as headingXlargeRegular,
  Jt as headingXlargeSemibold,
  Kt as headingXsmallBold,
  Nt as headingXsmallItalic,
  Qt as headingXsmallRegular,
  Yt as headingXsmallSemibold,
  pf as linkColors,
  xd as linkPrimaryStateActive,
  Pd as linkPrimaryStateDefault,
  Ad as linkPrimaryStateHover,
  Wd as linkSecondaryStateActive,
  Td as linkSecondaryStateDefault,
  zd as linkSecondaryStateHover,
  wd as linkStateVisited,
  Ud as linkTertiaryStateActive,
  Rd as linkTertiaryStateDefault,
  Md as linkTertiaryStateHover,
  Ld as neutralBackgroundBasic,
  Od as neutralBackgroundSubtle,
  Xd as neutralBorderBasic,
  _d as neutralBorderSubtle,
  vf as neutralColors,
  Vd as neutralContentBasic,
  jd as neutralContentSubtle,
  qd as neutralStateActive,
  Ed as neutralStateDefault,
  Gd as neutralStateHover,
  Wf as radii,
  R as radius0,
  M as radius100,
  L as radius200,
  O as radius300,
  X as radius400,
  _ as radius500,
  V as radiusFull,
  bf as selectedColors,
  Jd as selectedContentBasic,
  Kd as selectedContentSubtle,
  Nd as selectedStateActive,
  Qd as selectedStateDefault,
  Yd as selectedStateHover,
  q as shadow100,
  E as shadow200,
  G as shadow300,
  J as shadow400,
  Bf as shadowColors,
  Zd as shadowShadow100Color01,
  tf as shadowShadow200Color01,
  ef as shadowShadow300Color01,
  of as shadowShadow400Color01,
  zf as shadows,
  K as space0,
  N as space100,
  rt as space1000,
  ct as space1100,
  it as space1200,
  st as space1300,
  lt as space1400,
  dt as space1500,
  ft as space1600,
  mt as space1700,
  Q as space200,
  Y as space300,
  Z as space400,
  tt as space500,
  et as space600,
  ot as space700,
  nt as space800,
  at as space900,
  wf as spaces,
  Uf as styles,
  yf as textColors,
  nf as textPrimary,
  af as textSecondary,
  rf as textTertiary,
  Mf as themes
};
